export default "__VITE_ASSET__D1WqXVem__"